const wardTypeList = [
    {
        id: 1,
        name: 'City Corporation',
        name_bn: 'সিটি কর্পোরেশন'
    },
    {
        id: 2,
        name: 'Pauroshoba',
        name_bn: 'পৌরসভা'
    },
    {
        id: 3,
        name: 'Upazila',
        name_bn: 'উপজেলা'
    }
]
const hospitalTypeList = [{
    value: 1,
    text_en: 'UnpMedical College Hospitalin',
    text_bn: 'মেডিকেল কলেজ হাসপাতাল'
    },
    {
        value: 2,
        text_en: 'Specialized Hospital',
        text_bn: 'বিশেষায়িত হাসপাতাল'
    },
    {
        value: 3,
        text_en: 'General Hospital',
        text_bn: 'জেনারেল হাসপাতাল'
    },
    {
        value: 4,
        text_en: 'Upazila Health Complex',
        text_bn: 'উপজেলা হেলথ কমপ্লেক্স'
    }
]
const accountTypeList = [{
    value: 1,
    text_en: 'Current',
    text_bn: 'চলতি'
},
{
    value: 2,
    text_en: 'Savings',
    text_bn: 'সঞ্চয়ী'
}
]
const applicationClassList = [{
    value: 1,
    text_en: 'UnpMedical College Hospitalin',
    text_bn: 'মেডিকেল কলেজ হাসপাতাল'
    },
    {
        value: 2,
        text_en: 'Specialized Hospital',
        text_bn: 'বিশেষায়িত হাসপাতাল'
    },
    {
        value: 3,
        text_en: 'General Hospital',
        text_bn: 'জেনারেল হাসপাতাল'
    },
    {
        value: 4,
        text_en: 'Upazila Health Complex',
        text_bn: 'উপজেলা হেলথ কমপ্লেক্স'
    }
]
const paymentStatusList = [{
        value: 0,
        text_en: 'Unpain',
        text_bn: 'আনপেইড'
    },
    {
        value: 1,
        text_en: 'Paid',
        text_bn: 'পেইড'
    },
    {
        value: 2,
        text_en: 'Pending',
        text_bn: 'প্রক্রিয়াধীন'
    }
]
const maritalStatus = [
    {
        value: 1,
        text: 'Married',
        text_en: 'Married',
        text_bn: 'বিবাহিত'
    },
    {
        value: 2,
        text: 'Single',
        text_en: 'Single',
        text_bn: 'অবিবাহিত'
    },
    {
        value: 3,
        text: 'Divorced',
        text_en: 'Divorced',
        text_bn: 'তালাকপ্রাপ্ত'
    }
]
const reasonList = [
    {
        value: 1,
        text_en: 'Treatment',
        text_bn: 'চিকিৎসা'
    },
    {
        value: 2,
        text_en: 'Counseling',
        text_bn: 'পরামর্শ'
    },
    {
        value: 3,
        text_en: 'Application of Assistive Devices',
        text_bn: 'সহায়ক উপকরণ আবেদন'
    },
    {
        value: 4,
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]
const genderList = [
    {
        value: 1,
        text: 'Male',
        text_en: 'Male',
        text_bn: 'পুরুষ'
    },
    {
        value: 2,
        text: 'Female',
        text_en: 'Female',
        text_bn: 'নারী'
    },
    {
        value: 3,
        text: 'Transgender',
        text_en: 'Transgender',
        text_bn: 'হিজড়া'
    }
]

const healthConditionList = [
    {
        value: 1,
        text: 'Good',
        text_en: 'Good',
        text_bn: 'ভালো'
    },
    {
        value: 2,
        text: 'Roughly',
        text_en: 'Roughly',
        text_bn: 'মোটামুটি'
    },
    {
        value: 3,
        text: 'Bad',
        text_en: 'Bad',
        text_bn: 'খারাপ'
    }
]

const studentClassList = [
    {
        value: 1,
        text: 'Primary/Equivalent',
        text_en: 'Primary/Equivalent',
        text_bn: 'প্রাথমিক/সমমান'
    },
    {
        value: 2,
        text: 'Secondary/Equivalent',
        text_en: 'Secondary/Equivalent',
        text_bn: 'মাধ্যমিক/সমমান'
    },
    {
        value: 3,
        text: 'Higher Secondary/Equivalent',
        text_en: 'Higher Secondary/Equivalent',
        text_bn: 'উচ্চ মাধ্যমিক/সমমান'
    },
    {
        value: 4,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

const studyingClassList = [
    {
        value: 18,
        class_id: 1,
        text: 'Nazera',
        text_en: 'Nazera',
        text_bn: 'নাজেরা'
    },
    {
        value: 19,
        class_id: 1,
        text: 'Hifoz Nazera',
        text_en: 'Hifoz Nazera',
        text_bn: 'হিফজ নাজেরা'
    },
    {
        value: 14,
        class_id: 1,
        text: 'Hifzo',
        text_en: 'Hifzo',
        text_bn: 'হিফজ'
    },
    {
        value: 16,
        class_id: 1,
        text: 'Sishu',
        text_en: 'Sishu',
        text_bn: 'শিশু'
    },
    {
        value: 17,
        class_id: 1,
        text: 'Kg',
        text_en: 'Kg',
        text_bn: 'কেজি'
    },
    {
        value: 1,
        class_id: 1,
        text: '1st Class (General) / Ebtedayi-1st (Dakhil) / First Class Noorani (Qaumi)',
        text_en: '1st Class (General) / Ebtedayi-1st (Dakhil) / First Class Noorani (Qaumi)',
        text_bn: 'প্রথম শ্রেণী (সাধারণ) / এবতেদায়ী-১ম (দাখিল) / প্রথম শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 2,
        class_id: 1,
        text: '2nd Class (General) / Ebtedayi-2nd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_en: '2nd Class (General) / Ebtedayi-2nd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_bn: 'দ্বিতীয় শ্রেণী (সাধারণ) / এবতেদায়ী-২য় (দাখিল) / দ্বিতীয় শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 3,
        class_id: 1,
        text: '3rd Class (General) / Ebtedayi-3rd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_en: '3rd Class (General) / Ebtedayi-3rd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_bn: 'তৃতীয় শ্রেণী (সাধারণ) / এবতেদায়ী-৩য় (দাখিল) / দ্বিতীয় শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 4,
        class_id: 1,
        text: '4th Class (General) / Ebtedayi-4th (Dakhil) / Urdu Qaida Jamaat (Qaumi)',
        text_en: '4th Class (General) / Ebtedayi-4th (Dakhil) / Urdu Qaida Jamaat (Qaumi)',
        text_bn: 'চতুর্থ শ্রেণী (সাধারণ) / এবতেদায়ী-৪র্থ (দাখিল) / উর্দু কায়দা জামাত (কাওমি)'
    },
    {
        value: 5,
        class_id: 1,
        text: '5th Class (General) / Ebtedayi-5th (Dakhil) / Tahsi Jamaat (Qaumi)',
        text_en: '5th Class (General) / Ebtedayi-5th (Dakhil) / Tahsi Jamaat (Qaumi)',
        text_bn: 'পঞ্চম শ্রেণী (সাধারণ) / এবতেদায়ী-৫ম (দাখিল) / তাহসীর জামাত (কাওমি)'
    },
    {
        value: 6,
        class_id: 2,
        text: '6th Class (General) / Dakhil-6th (Dakhil) / Meezan Jamaat (Qaumi)',
        text_en: '6th Class (General) / Dakhil-6th (Dakhil) / Meezan Jamaat (Qaumi)',
        text_bn: 'ষষ্ঠ শ্রেণী (সাধারণ) / দাখিল-৬ষ্ট (দাখিল) / মীযান জামাত (কাওমি)'
    },
    {
        value: 7,
        class_id: 2,
        text: '7th Class (General) / Dakhil-7th (Dakhil) / Nahremi Jamaat (Qaumi)',
        text_en: '7th Class (General) / Dakhil-7th (Dakhil) / Nahremi Jamaat (Qaumi)',
        text_bn: 'সপ্তম শ্রেণী (সাধারণ) / দাখিল-৭ম (দাখিল) / নাহরেমীর জামাত (কাওমি)'
    },
    {
        value: 8,
        class_id: 2,
        text: '8th Class (General) / Dakhil-8th (Dakhil) / Hedayatunnah (Qaumi)',
        text_en: '8th Class (General) / Dakhil-8th (Dakhil) / Hedayatunnah (Qaumi)',
        text_bn: 'অষ্টম শ্রেণী (সাধারণ) / দাখিল-৮ম (দাখিল) / হেদায়াতুন্নাহ (কাওমি)'
    },
    {
        value: 9,
        class_id: 2,
        text: '9th Class (General) / Dakhil- 9th (Dakhil) / Kafia (Qaum)',
        text_en: '9th Class (General) / Dakhil- 9th (Dakhil) / Kafia (Qaum)',
        text_bn: 'নবম শ্রেণী (সাধারণ) / দাখিল- ৯ম (দাখিল) / কাফিয়া (কাওমি)'
    },
    {
        value: 10,
        class_id: 2,
        text: '10th Class (General) / Dakhil- 10th (Dakhil) / Sharhe Jami (Qaumi)',
        text_en: '10th Class (General) / Dakhil- 10th (Dakhil) / Sharhe Jami (Qaumi)',
        text_bn: 'দশম শ্রেণী (সাধারণ) / দাখিল- ১০ম (দাখিল) / শরহে জামী (কাওমি)'
    },
    {
        value: 11,
        class_id: 3,
        text: '11th Class (General) / Alim-1st Year (Dakhil) / Sharhe Bekaya (Qaum)',
        text_en: '11th Class (General) / Alim-1st Year (Dakhil) / Sharhe Bekaya (Qaum)',
        text_bn: 'একাদশ শ্রেণী (সাধারণ) / আলিম-১ম বর্ষ (দাখিল) / শরহে বেকায়া (কাওমি)'
    },
    {
        value: 12,
        class_id: 3,
        text: '12th Class (General) / Alim-2nd Year (Dakhil) / Jalalain (Qaum)',
        text_en: '12th Class (General) / Alim-2nd Year (Dakhil) / Jalalain (Qaum)',
        text_bn: 'দ্বাদশ শ্রেণী (সাধারণ) / আলিম-২য় বর্ষ (দাখিল) / জালালাইন (কাওমি)'
    }
]

const studentGenderList = [
    {
        value: 1,
        text: 'Boy',
        text_en: 'Boy',
        text_bn: 'ছেলে'
    },
    {
        value: 2,
        text: 'Girl',
        text_en: 'Girl',
        text_bn: 'মেয়ে'
    },
    {
        value: 3,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]
const religionList = [
    {
        value: 1,
        text: 'Muslim',
        text_en: 'Muslim',
        text_bn: 'মুসলিম'
    },
    {
        value: 2,
        text: 'Hindu',
        text_en: 'Hindu',
        text_bn: 'হিন্দু'
    },
    {
        value: 3,
        text: 'Boudha',
        text_en: 'Boudha',
        text_bn: 'বৌদ্ধ'
    },
    {
        value: 4,
        text: 'Christian ',
        text_en: 'Christian',
        text_bn: 'খ্রিষ্টান'
    },
    {
        value: 5,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

const meritalStatuslList = [
    {
        value: 1,
        text: 'Unmarried',
        text_en: 'Unmarried',
        text_bn: 'অবিবাহিত'
    },
    {
        value: 2,
        text: 'Married',
        text_en: 'Married',
        text_bn: 'বিবাহিত'
    },
    {
        value: 3,
        text: 'Divorced',
        text_en: 'Divorced',
        text_bn: 'বিধবা/বিপত্নীক'
    },
    {
        value: 4,
        text: 'Seperated ',
        text_en: 'Seperated',
        text_bn: 'স্বামী/স্ত্রী পৃথক'
    },
    {
        value: 5,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'তালাক প্রাপ্ত/বিবাহ বিচ্ছিন্ন'
    }
]

const applicationTypeList = [
    {
        value: 1,
        text_en: 'Self',
        text_bn: 'নিজ'
    },
    {
        value: 2,
        text_en: 'On Behalf',
        text_bn: 'পক্ষে'
    },
    {
        value: 3,
        text_en: 'Unknown',
        text_bn: 'অজ্ঞাত '
    }
]

const diseaseList = [
    {
        value: 1,
        text_en: 'Cancer',
        text_bn: 'ক্যান্সার'
    },
    {
        value: 2,
        text_en: 'Kidney Disease',
        text_bn: 'কিডনী রোগ'
    },
    {
        value: 3,
        text_en: 'Liver Cirrhosis',
        text_bn: 'লিভার সিরোসিস'
    },
    {
        value: 4,
        text_en: 'Paralysis',
        text_bn: 'প্যারালাইসিস'
    },
    {
        value: 5,
        text_en: 'Heart Disease',
        text_bn: 'হৃদরোগ'
    },
    {
        value: 7,
        text_en: 'Leukemia',
        text_bn: 'লিউকেমিয়া'
    },
    {
        value: 6,
        text_en: 'Thalassemia',
        text_bn: 'থ্যালাসেমিয়া'
    }
]

const qoutaList = [
    {
        value: 1,
        text_en: 'Ministry Level (25%)',
        text_bn: 'মন্ত্রণালয় পর্যায়ে (২৫%)'
    },
    {
        value: 2,
        text_en: 'District Level (75%)',
        text_bn: 'জেলা পর্যায় (৭৫%)'
    }
]

const bloodGroupList = [
    {
        value: 1,
        text_en: 'A+',
        text_bn: 'A+'
    },
    {
        value: 2,
        text_en: 'A-',
        text_bn: 'A-'
    },
    {
        value: 3,
        text_en: 'B+',
        text_bn: 'B+'
    },
    {
        value: 4,
        text_en: 'B-',
        text_bn: 'B-'
    },
    {
        value: 5,
        text_en: 'O+',
        text_bn: 'O+'
    },
    {
        value: 6,
        text_en: 'O-',
        text_bn: 'O-'
    },
    {
        value: 7,
        text_en: 'AB+',
        text_bn: 'AB+'
    },
    {
        value: 8,
        text_en: 'AB-',
        text_bn: 'AB-'
    }
]

const subServiceTypeList = [
    {
        value: 1,
        text_en: 'Medicine',
        text_bn: 'ঔষধ'
    },
    {
        value: 2,
        text_en: 'Medical Test',
        text_bn: 'পরীক্ষা-নিরীক্ষা'
    },
    {
        value: 3,
        text_en: 'Clothing And Other',
        text_bn: 'বস্ত্র'
    },
    {
        value: 4,
        text_en: 'Blood',
        text_bn: 'রক্ত'
    },
    {
        value: 5,
        text_en: 'Glass',
        text_bn: 'চশমা'
    },
    {
        value: 6,
        text_en: 'Food',
        text_bn: 'পথ্য'
    },
    {
        value: 7,
        text_en: 'Dialysis',
        text_bn: 'ডায়ালাইজার'
    },
    {
        value: 8,
        text_en: 'Other (If any other service required write in description)',
        text_bn: 'অন্যান্য (অন্য কোন সেবা থাকলে বিবরণে লিখুন)'
    },
    {
        value: 9,
        text_en: 'Fares for transportation',
        text_bn: 'যাতায়াত ভাড়া'
    },
    {
        value: 10,
        text_en: 'Transportation of corpses/ Funeral etc',
        text_bn: 'লাশ পরিবহন/ মৃতের সৎকার ইত্যাদি'
    },
    {
        value: 11,
        text_en: 'Wheelchair',
        text_bn: 'হুইল চেয়ার'
    },
    {
        value: 12,
        text_en: 'Artificial Arms',
        text_bn: 'কৃত্রিম অঙ্গ'
    },
    {
        value: 13,
        text_en: 'Therapy',
        text_bn: 'থেরাপি'
    }
]

const hospitalCategoryList = [
{
    value: 1,
    text_en: 'General',
    text_bn: 'জেনারেল'
},
{
    value: 2,
    text_en: 'Burn Unit',
    text_bn: 'বার্ন ইউনিট'
}
]

const burnPatientTypeList = [
    {
        value: 1,
        text: 'এসিড দগ্ধ',
        text_bn: 'এসিড দগ্ধ',
        text_en: 'Acid Burn'
    },
    {
        value: 2,
        text: 'দুর্ঘটনাজনিত কারণে দগ্ধ',
        text_bn: 'দুর্ঘটনাজনিত কারণে দগ্ধ',
        text_en: 'Accidental Burn'
    }
]

const subOccupationListx = [
    {
        value: 1,
        text_en: 'Government Employee',
        text_bn: 'সরকারি চাকুরিজীবী'
    },
    {
        value: 2,
        text_en: 'Private Employee',
        text_bn: 'বেসরকারি চাকুরিজীবী'
    },
    {
        value: 3,
        text_en: 'Banker',
        text_bn: 'ব্যাংকার'
    },
    {
        value: 4,
        text_en: 'Businessman',
        text_bn: 'ব্যবসায়ী'
    },
    {
        value: 5,
        text_en: 'Lawyer',
        text_bn: 'আইনজীবী'
    },
    {
        value: 6,
        text_en: 'PeopleS Representatives',
        text_bn: 'জনপ্রতিনিধি'
    },
    {
        value: 7,
        text_en: 'Housewife',
        text_bn: 'গৃহিণী'
    },
    {
        value: 8,
        text_en: 'Immigrant',
        text_bn: 'প্রবাসী'
    },
    {
        value: 9,
        text_en: 'Entrepreneur',
        text_bn: 'উদ্যোক্তা'
    }
]

const subOccupationList = [
    {
        value: 1,
        text_en: 'Blacksmith',
        text_bn: 'কামার'
    },
    {
        value: 2,
        text_en: 'Potter',
        text_bn: 'কুমার'
    },
    {
        value: 3,
        text_en: 'Barber',
        text_bn: 'নাপিত'
    },
    {
        value: 4,
        text_en: 'Bamboo & Cane Workers',
        text_bn: 'বাঁশ ও বেত শ্রমিক'
    },
    {
        value: 5,
        text_en: 'Cobbler',
        text_bn: 'মুচি'
    },
    {
        value: 6,
        text_en: 'Farmer',
        text_bn: 'কৃষক'
    },
    {
        value: 7,
        text_en: 'Fishermen',
        text_bn: 'জেলে'
    },
    {
        value: 8,
        text_en: 'Day Labourer',
        text_bn: 'দিনমজুর'
    },
    {
        value: 9,
        text_en: 'Weaver',
        text_bn: 'তাঁতি'
    },
    {
        value: 10,
        text_en: 'Porter',
        text_bn: 'কুলি'
    },
    {
        value: 11,
        text_en: 'Housewife',
        text_bn: 'গৃহিণী'
    },
    {
        value: 12,
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

const educationalBoardList = [
    {
        value: 1,
        text: 'Dhaka',
        text_en: 'Dhaka',
        text_bn: 'ঢাকা'
    },
    {
        value: 2,
        text: 'Rajshahi',
        text_en: 'Rajshahi',
        text_bn: 'রাজশাহী'
    },
    {
        value: 3,
        text: 'Cumilla',
        text_en: 'Cumilla',
        text_bn: 'কুমিল্লা'
    },
    {
        value: 4,
        text: 'Jashore',
        text_en: 'Jashore',
        text_bn: 'যশোর'
    },
    {
        value: 5,
        text: 'Chattogram',
        text_en: 'Chattogram',
        text_bn: 'চট্টগ্রাম'
    },
    {
        value: 6,
        text: 'Barishal',
        text_en: 'Barishal',
        text_bn: 'বরিশাল'
    },
    {
        value: 7,
        text: 'Sylhet',
        text_en: 'Sylhet',
        text_bn: 'সিলেট'
    },
    {
        value: 8,
        text: 'Madrasah',
        text_en: 'Madrasah',
        text_bn: 'মাদ্রাসা'
    },
    {
        value: 9,
        text: 'Technical',
        text_en: 'Technical',
        text_bn: 'কারিগরি'
    },
    {
        value: 10,
        text: 'Dinajpur',
        text_en: 'Dinajpur',
        text_bn: 'দিনাজপুর'
    },
    {
        value: 11,
        text: 'Mymensingh',
        text_en: 'Mymensingh',
        text_bn: 'ময়মনসিংহ'
    },
    {
        value: 12,
        text: 'BOU',
        text_en: 'BOU',
        text_bn: 'বিওইউ'
    }
]
const educationalResultTypeList = [
    {
        value: 0,
        text: 'Do not mention',
        text_en: 'Do not mention',
        text_bn: 'উল্লেখ করবেন না'
    },
    {
        value: 1,
        text: 'First Division/Class',
        text_en: 'First Division/Class',
        text_bn: 'প্রথম বিভাগ/শ্রেণী'
    },
    {
        value: 2,
        text: 'Second  Division/Class',
        text_en: 'Second  Division/Class',
        text_bn: 'দ্বিতীয় বিভাগ/শ্রেণী'
    },
    {
        value: 3,
        text: 'Third Division/Class',
        text_en: 'Third Division/Class',
        text_bn: 'তৃতীয় বিভাগ/শ্রেণী'
    },
    {
        value: 4,
        text: 'Grade',
        text_en: 'Grade',
        text_bn: 'গ্রেড'
    },
    {
        value: 5,
        text: 'Appeared',
        text_en: 'Appeared',
        text_bn: 'প্রকাশিত'
    },
    {
        value: 6,
        text: 'Enrolled',
        text_en: 'Enrolled',
        text_bn: 'নথিভুক্ত'
    },
    {
        value: 7,
        text: 'Awarded',
        text_en: 'Awarded',
        text_bn: 'ভূষিত'
    },
    {
        value: 8,
        text: 'Pass',
        text_en: 'Pass',
        text_bn: 'পাস'
    }
]
const monthList = [
    {
        value: 1,
        text_en: 'January',
        text_bn: 'জানুয়ারী'
    },
    {
        value: 2,
        text_en: 'February',
        text_bn: 'ফেব্রুয়ারী'
    },
    {
        value: 3,
        text_en: 'March',
        text_bn: 'মার্চ'
    },
    {
        value: 4,
        text_en: 'April',
        text_bn: 'এপ্রিল'
    },
    {
        value: 5,
        text_en: 'May',
        text_bn: 'মে'
    },
    {
        value: 6,
        text_en: 'June',
        text_bn: 'জুন'
    },
    {
        value: 7,
        text_en: 'July',
        text_bn: 'জুলাই'
    },
    {
        value: 8,
        text_en: 'August',
        text_bn: 'আগস্ট'
    },
    {
        value: 9,
        text_en: 'September',
        text_bn: 'সেপ্টেম্বর'
    },
    {
        value: 10,
        text_en: 'October',
        text_bn: 'অক্টোবর'
    },
    {
        value: 11,
        text_en: 'November',
        text_bn: 'নভেম্বর'
    },
    {
        value: 12,
        text_en: 'December',
        text_bn: 'ডিসেম্বর'
    }
]
const formTypeList = [
    {
        value: 1,
        text_en: 'Application form for receiving special grant for disabled students/poor and meritorious students',
        text_bn: 'প্রতিবন্ধী শিক্ষার্থী/দরিদ্র মেধাবী শিক্ষার্থীর বিশেষ অনুদান প্রাপ্তির আবেদন ফরম'
    },
    {
        value: 2,
        text_en: 'Application form for receiving special grants for distressed, helpless, sick, disabled, homeless individuals or organizations',
        text_bn: 'দুস্থ, অসহায়, অসুস্থ, প্রতিবন্ধী, গৃহহীন ব্যক্তি বা সংগঠনের বিশেষ অনুদান প্রাপ্তির আবেদন ফরম'
    }
]
const specialCategoryList = [
    {
        value: 1,
        text_en: 'Special grant for disabled students/poor and meritorious students',
        text_bn: 'প্রতিবন্ধী শিক্ষার্থী/দরিদ্র মেধাবী শিক্ষার্থী'
    },
    {
        value: 2,
        text_en: 'Distressed, helpless, sick, disabled, homeless individuals or organizations',
        text_bn: 'দুস্থ, অসহায়, অসুস্থ, প্রতিবন্ধী, গৃহহীন ব্যক্তি বা সংগঠন'
    }
]

export default {
    accountTypeList,
    maritalStatus,
    reasonList,
    genderList,
    healthConditionList,
    studyingClassList,
    studentClassList,
    studentGenderList,
    religionList,
    meritalStatuslList,
    diseaseList,
    qoutaList,
    bloodGroupList,
    subServiceTypeList,
    paymentStatusList,
    wardTypeList,
    applicationTypeList,
    hospitalCategoryList,
    burnPatientTypeList,
    hospitalTypeList,
    applicationClassList,
    educationalBoardList,
    educationalResultTypeList,
    monthList,
    subOccupationListx,
    subOccupationList,
    formTypeList,
    specialCategoryList
}
